/**
 * Skeleton — loading placeholder primitive (Block 6.A).
 *
 * Used in place of spinners (instant perception per ADR-024 D9 a11y +
 * cross-cutting #1 optimistic UI spirit).
 *
 * UX-5 re-skin: token-only surfaces (sand shimmer on the warm-neutral
 * scale, sage-tinted hairline) — no raw gray-*. The raw-grey lint holds
 * this (the file's grandfather entry was removed with the re-skin).
 */

import type { ReactNode } from 'react';

export interface SkeletonProps {
  /** Approximate width — Tailwind class string, e.g. "w-full" or "w-32". */
  width?: string;
  /** Approximate height — Tailwind class string, e.g. "h-4". */
  height?: string;
  /** Optional className additions. */
  className?: string;
}

export function Skeleton({
  width = 'w-full',
  height = 'h-4',
  className = '',
}: SkeletonProps): ReactNode {
  return (
    <div
      aria-hidden="true"
      className={`bg-sand rounded-tight animate-pulse ${width} ${height} ${className}`}
    />
  );
}

export function SkeletonRow(): ReactNode {
  return (
    <div className="px-3 py-3 border-b border-sage-800/[8%]">
      <Skeleton width="w-2/3" height="h-4" className="mb-2" />
      <Skeleton width="w-1/3" height="h-3" />
    </div>
  );
}
